import * as React from 'react';
import { useState, useRef, useEffect } from 'react';

interface Props {
    onRemove: () => void;
    onRemoveAndAbove: () => void;
    onRemoveAndBelow: () => void;
    disabled?: boolean;
}

export function RemoveDropdownButton({ onRemove, onRemoveAndAbove, onRemoveAndBelow, disabled }: Props) {
    const [open, setOpen] = useState(false);
    const wrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!open) return;
        function onDocClick(e: MouseEvent) {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
                setOpen(false);
            }
        }
        document.addEventListener('mousedown', onDocClick);
        return () => document.removeEventListener('mousedown', onDocClick);
    }, [open]);

    return (
        <div className="btn-group btn-group-sm" ref={wrapperRef}>
            <button
                type="button"
                className="btn btn-sm btn-outline-danger"
                onClick={onRemove}
                disabled={disabled}
                title="Remove just this date"
            >
                Remove
            </button>
            <button
                type="button"
                className="btn btn-sm btn-outline-danger dropdown-toggle dropdown-toggle-split"
                aria-expanded={open}
                onClick={() => setOpen(o => !o)}
                disabled={disabled}
            >
                <span className="visually-hidden">Toggle Dropdown</span>
            </button>
            {open && (
                <ul className="dropdown-menu show" style={{ display: 'block', position: 'absolute', right: 0, top: '100%', zIndex: 1080 }}>
                    <li>
                        <button
                            type="button"
                            className="dropdown-item"
                            onClick={() => { setOpen(false); onRemoveAndAbove(); }}
                        >
                            Remove and above
                        </button>
                    </li>
                    <li>
                        <button
                            type="button"
                            className="dropdown-item"
                            onClick={() => { setOpen(false); onRemoveAndBelow(); }}
                        >
                            Remove and below
                        </button>
                    </li>
                </ul>
            )}
        </div>
    );
}
